import React from "react";
import "./Testimonials_card.css";

function Testimonials_card({ val }) {
  return (
    <>
      <section className="Testimonials_card">
        <div className="row justify-content-center">
          <div className="profile_holder">
            <div className="img_holder">
              <img
                className="Profile_img"
                src={process.env.REACT_APP_IMG_URL + val?.image}
                //  src={

                //  "/assets/images/home/testimonials/User_1.png"
                // }
                alt={"Profile_img"}
              />
              <div className="quote_holder">
                <img
                  className="quote_img"
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/home/testimonials/quote.png"
                  }
                  alt={"Profile_img"}
                />
              </div>
            </div>

            <div className="name_holder">
              <h5>{val?.name}</h5>
              <p>{val?.description}</p>
              {/* <h5>Smita Lad</h5>
                <p>dfndhg dfdshf vhsdhsdkshdig vsdj djdhd fdfn dsgiod gdbgd gndg dgbg fwef </p> */}
            </div>
          </div>
        </div>

        <div className="text_holder">
          <p>
            {val?.sub_name}
            {/* Smita Lad */}
          </p>
        </div>
      </section>
    </>
  );
}

export default Testimonials_card;
